import request from '@/utils/request'

// 获取点位设备列表
export const getDeviceList = (data) => {
    return request({
        url: '/HVAC/thermostat/lists',
        params: data
    })
}
// 设备tree
export const getDeviceTree = () => {
    return request({
        url: '/HVAC/thermostat/tree'
    })
}
// 设备点位信息-修改
export const editDeviceInfo = (data) => {
    return request({
        url: '/HVAC/thermostat/manage',
        method: 'PUT',
        data
    })
}

// 设备点位-添加
export const addIMEI = (data) => {
    return request({
        url: '/HVAC/thermostat/manage',
        method: 'POST',
        data
    })
}

// 设备点位-删除
export const deleteDevice = (id) => {
    return request({
        url: `/HVAC/thermostat/${id}`,
        method: 'DELETE'
    })
}
// 设备点位-远程控制
export const batchPatchValveParams = (data) => {
    return request({
        url: '/HVAC/thermostat/control',
        method: 'POST',
        data
    })
}
// 上报数据列表
export const getReportData = (data) => {
    return request({
        url: '/HVAC/thermostat/report_data',
        params: data
    })
}
// 设置离线判定时间
export const getOfflineTime = (data) => {
    return request({
        url: '/HVAC/setting/manage',
        method: 'GET',
        params: data
    })
}
export const setOfflineTime = (data) => {
    return request({
        url: '/HVAC/setting/manage',
        method: 'POST',
        data
    })
}
export const putOfflineTime = (data) => {
    return request({
        url: '/HVAC/setting/manage',
        method: 'PUT',
        data
    })
}
// 最新数据导出
export const HVACReportDataTimeExport = (data) => {
    return request({
        url: '/HVAC/thermostat/report_data/export',
        method: 'POST',
        data
    })
}
export const batchPatch = (data) => {
    return request({
        url: '/HVAC/thermostat/batch_delete',
        method: 'POST',
        data: {
            id_list: data
        }
    })
}

// 固件文件列表
export const getUpgradeFileList = (data) => {
    return request({
        url: '/HVAC/upgrade_file/manage',
        params: data
    })
}
// 添加固件文件
export const addUpgradeFileApi = (data) => {
    return request({
        url: '/HVAC/upgrade_file/manage',
        method: 'POST',
        data
    })
}
// 修改固件文件
export const putUpgradeFileApi = (data) => {
    return request({
        url: '/HVAC/upgrade_file/manage',
        method: 'PUT',
        data
    })
}

// 删除固件文件
export const deleteUpgradeFileApi = (id) => {
    return request({
        url: '/HVAC/upgrade_file/manage',
        method: 'DELETE',
        data: {
            id
        }
    })
}
// 远程升级固件文件
export const upgradeFileApi = (data) => {
    return request({
        url: '/HVAC/thermostat/upgrade',
        method: 'POST',
        data
    })
}
// 获取分组管理列表
export const getGroupList = (data) => {
    return request({
        url: '/HVAC/thermostat_group/lists',
        params: data
    })
}
// 添加分组
export const addGroupApi = (data) => {
    return request({
        url: '/HVAC/thermostat_group/manage',
        method: 'POST',
        data
    })
}
// 修改分组
export const putGroupApi = (data) => {
    return request({
        url: '/HVAC/thermostat_group/manage',
        method: 'PUT',
        data
    })
}
// 删除分组
export const deleteGroupApi = (id) => {
    return request({
        url: `/HVAC/thermostat_group/${id}`,
        method: 'DELETE'
    })
}
// 分组详情
export const getGroupDetailApi = (id) => {
    return request({
        url: `/HVAC/thermostat_group/${id}`
    })
}
